import React, { Fragment } from "react";

const MensajeAleta = ({ opcion }) => {
  return (
    <Fragment>
      {/* dataModalCode.validate: 3 tiene correo y celular; 
        2 tiene solo celular, 1 tiene solo correo, 0 no tiene nada  */}
      {opcion === 3 ? (
        <div className="alert alert-warning">
          Para confirmar su solicitud se generará un token digital de 6 dígitos, a
          continuación indicanos donde quieres recibir tu token.
        </div>
      ) : opcion === 2 ? (
        <div className="alert alert-warning">
          Para confirmar su solicitud se generará un token digital de 6 dígitos.
        </div>
      ) : opcion === 1 ? (
        <div className="alert alert-warning">
          Para confirmar su solicitud se generará un token digital de 6 dígitos.
        </div>
      ) : (
        <div className="alert alert-warning">
          Lo sentimos pero necesitamos que sus datos sean actualizados, tanto{" "}
          <strong>Correo</strong>, como <strong>Celular</strong>.
        </div>
      )}
    </Fragment>
  );
};

export default MensajeAleta;
